import { makeAutoObservable } from 'mobx'
import { openApi } from '../request'
import i from '../../translations/i'

interface SelectSelect {
    type: string
    value: any
    value_array: any
}

class __select {

    limit = 10
    offset = 0
    page = 1
    total = 0

    categoryID = 0

    types = [
        { label: i.t('def:selectTypes.none'), value: '' },
        { label: i.t('def:selectTypes.productCategory'), value: 'productcategory' },
        { label: i.t('def:selectTypes.cart'), value: 'cart' },
        { label: i.t('def:selectTypes.favorite'), value: 'favorite' },
        { label: i.t('def:selectTypes.cabinet'), value: 'cabinet' },
        { label: i.t('def:selectTypes.home'), value: 'home' },
        { label: i.t('def:selectTypes.news'), value: 'news' },
        { label: i.t('def:selectTypes.product'), value: 'product' },
        { label: i.t('def:selectTypes.products'), value: 'products' },
        { label: i.t('def:selectTypes.contacts'), value: 'contacts' },
        { label: i.t('def:selectTypes.depart'), value: 'depart' },
        { label: i.t('def:selectTypes.feedback'), value: 'feedback' },
        { label: i.t('def:selectTypes.questioning'), value: 'questioning' },
        { label: i.t('def:selectTypes.url'), value: 'url' },
        { label: i.t('def:selectTypes.url_blank'), value: 'url_blank' },
        { label: i.t('def:selectTypes.orders'), value: 'orders' },
        { label: i.t('def:selectTypes.notifications'), value: 'notifications' },
        { label: i.t('def:selectTypes.faq'), value: 'faq' },
        { label: i.t('def:selectTypes.promo'), value: 'promo' },
        { label: i.t('def:selectTypes.purchased_product'), value: 'purchased_product' },
    ]

    select: SelectSelect = {
        type: '',
        value: '',
        value_array: []
    }

    save_type: boolean = true

    list: any[] = []

    elements: any = []
    element: any = null

    filter = {
        name: ''
    }

    constructor() {
        makeAutoObservable(this)
    }

    clear() {
        this.select = {
            type: '',
            value: '',
            value_array: []
        }
        // this.list = []
        // this.filter = {
        //     name: ''
        // }
        // this.element = null
        // this.elements = []
    }

    setTypesElements() {
        this.types = this.types.filter(el => el.value !== '')
    }

    getTypeByCode(code: string) {
        const index = this.types.findIndex(el => el.value === code)
        if(index > -1) return this.types[index].label
        return ''
    }

    getDefaultValueByType(type: string) {
        if(type === 'products') return []
        else return ''
    }

    setValue(value: any) {
        console.log(value)
        this.select.value = value
    }

    setValueMultiple(value: any) {
        if(this.select.value_array.findIndex((el: any) => `${el}` === `${value}`) > -1) {
            this.select.value_array = this.select.value_array.filter((el: any) => `${el}` !== `${value}`)
        } else {
            let array = this.select.value_array
            array.push(value)
            this.select.value_array = array
        }
    }

    setElements(elements: any) {
        this.elements = elements
    }

    setElement(element: any) {
        this.element = element
    }

    setType(type: string, element: any = false) {

        this.limit = 10
        this.offset = 0
        this.page = 1
        this.total = 0

        this.select = {
            type: type,
            value: this.getDefaultValueByType(type),
            value_array: []
        }

        if(element) {
            if(Array.isArray(element)) this.select.value_array = element
            else this.select.value = element
        }
    }

    setPage(page: number) {
        this.offset = page > 1 ? (this.limit * page) - this.limit : 0
        this.page = page
    }

    getNews() {
        openApi('get', `/news?active=1&limit=${this.limit}&offset=${this.offset}`)
            .then(success => {
                console.log(success)
                success = success.data
                this.list = success.list
                this.total = success.count
            })
    }

    getProducts() {

        let uri = `/products/list?limit=${this.limit}&page=${this.page}&filter[view]=1&with[]=image`
        if(this.filter.name !== '') uri += `&filter[name]=${this.filter.name}`

        openApi('get', uri)
          .then((success) => {
              console.log(success)
              this.list = success.data
              this.total = success.total
          })
    }

    getPoints() {
        openApi('get', `/places?limit=10000000`)
            .then((result) => {
                this.list = result.data
                this.total = result.total
            })
    }

    getFeedback() {
        openApi('get', `/feedback?limit=${this.limit}&page=${this.page}`)
            .then(result => {
                console.log(result)
                this.total = result.total
                this.page = result.page
                this.limit = result.limit
                this.list = result.data
            })
    }

    getForm() {
        let path = `/forms?limit=${this.limit}&page=${this.page}`

        openApi('get', path)
            .then(result => {
                console.log(result)
                this.total = result.total
                this.page = result.page
                this.limit = result.limit
                this.list = result.data
            })
    }

}

export default new __select()